<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Orders from '../components/Orders.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import { DatePicker } from "@svelte-plugins/datepicker";
    import Pagination from '../components/Pagination.svelte'; 
    import { updateUrlParam } from '../base/url.js';
    import { removeProduct , addProduct } from '../base/products.js';
    import { format } from 'date-fns';

    let isLoading = false;

    let searchTerm = '';
    let prevsearchTerm = '';
    let pages = 1;
    let limit = "50";
    let currentPage = 1;
    let count = 0;
    let urlParams = {}
    let tabSelected = 1;
    let tabStore = 1;
    let customers_count = 0;
    let products = [];
    
    let allChecked = false;

    function checkBoxAll() {
        // Toggle the state of `allChecked`
        allChecked = !allChecked;

        // Set each `enabled` property to match the `allChecked` state
        for (const key in products) {
          products[key].enabled = allChecked;
        }
    }

    

    
    onMount(async() => {

        //console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        }

        
        isLoading = true;

        let postData = {};

        console.log($UserStore.manager_platform_id)

        await get_my_products();

        

        
    })    





    const get_my_products = async(filters={}) => {

        const url = new URL(window.location);
        const hashParams = new URLSearchParams(url.hash.split('?')[1]);
        const pageParam = hashParams.get('page');
        const limit_amount = hashParams.get('limit');
        const searchParam = hashParams.get('search');

        if (searchParam) {
            searchTerm = searchParam;
            filters.search = searchTerm;
        }

        if (pageParam) {
            currentPage = pageParam;
        } 
        
        
        if (limit_amount) {
            limit = limit_amount            
        } 
              

        if (prevsearchTerm!=searchTerm) {
            currentPage = 1;  
            urlParams.page = currentPage;     
            updateUrlParam(urlParams)              
        }


        let postData = {};

        isLoading = true;  

        postData.action = 'my_products';
        postData.filters = filters;  
        postData.page = currentPage;
        postData.limit = parseInt(limit);
        postData.token = $UserStore.token
        let response = await fetchData(postData);

        isLoading = false;    

        count = response.count;
        pages = response.count / parseInt(limit)

        products = response.data;



    }

    async function syncProducts() {


        let postData = {};

        isLoading = true;  

        postData.action = 'sync_products';
        postData.token = $UserStore.token
        let response = await fetchData(postData);

        isLoading = false;    

    }

    const filterOrders = async() => {

        urlParams.search = searchTerm
        updateUrlParam(urlParams);
        await get_shipments();     

    }


    const previous = async(event) => {

        currentPage = event.detail.currentPage;
        urlParams.page = currentPage
        updateUrlParam(urlParams);
        get_shipments();

    }

    const next = async(event) => {

        currentPage = event.detail.currentPage;        
        urlParams.page = currentPage
        updateUrlParam(urlParams);  
        get_shipments();    
    }

    const tabSelect = async() => {

        urlParams.tab = tabSelected
        urlParams.store = tabStore;
        updateUrlParam(urlParams);  
        get_shipments();    
    }

    const updateLimit = async()=> {
        urlParams.limit = limit.toString()
        updateUrlParam(urlParams);  
        get_shipments();    
    }


    const handleSubmit = () => {

    }

    const removeProductAction = async(item)=>{
      let result = await removeProduct(item)
      if (result) {
        item.merchant_product_id = 0;
      }
      products = products;
    }

    const addProductAction = async(item)=>{
      let result = await addProduct(item)
      if (result) {
        item.merchant_product_id = 1;
      }
      products = products;
    }




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">       
            
          <div class="flex items-align justify-between p-5">
             <h1 class="text-[20px]">{$_('products.my_products')}</h1>
             <button class="text-[14px] cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] w-[220px] text-enter" type="submit" on:click={()=> syncProducts() }>{$_('products.sync_products')}</button>

          </div>
          <div class="flex items-align justify-between p-5 pt-0">
            <form id="orders-filters" class="orders-filters flex" on:submit|preventDefault={handleSubmit}>
                <input type="text" placeholder="{$_('orders.free_text')}" bind:value={searchTerm} class="w-[200px] rounded-e-[0px] py-[7px]">
                <button class="cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] rounded-s-[0px] w-[120px] text-enter" type="submit" on:click={()=> filterOrders() }>{$_('orders.filter')}</button>
            </form>

            <div class="sort_flex">
              
                <div class="order_sort">
                    <select bind:value={limit} on:change={updateLimit}>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="400">400</option>
                        <option value="400">400</option>
                    </select>
                </div>
            </div>
          </div>

          <div class="table table-shipments orders">
            <div class="head">
                <div class="input_con radio checkbox text-center">            
                    <input id="id_all" type="checkbox" bind:checked={allChecked} on:click={checkBoxAll}>       
                    <label for="id_all"><span></span></label>     
                </div>
                <div>{$_('products.image')}</div>
                <div>{$_('products.name')}</div>
                <div>{$_('products.selling_price')}</div>
                <div>{$_('products.commision')}</div>
                <div>{$_('products.sales')}</div>
                <div>{$_('products.actions')}</div>
            </div>
            {#each products as item,index}
            <div class="content">
                <div class="input_con radio checkbox text-center">            
                    <input id="enabled{index}" type="checkbox" bind:value={item.enabled} bind:checked={item.enabled}>       
                    <label for="enabled{index}"><span></span></label>     
                </div>
                <div>
                  <div class="mobile">{$_('products.image')}</div>
                  <div><img src="{item.image}" class="w-[40px]"></div>
                </div>
                <div>
                    <div class="mobile">{$_('products.order_name')}</div>
                    <div>{item.name}</div>
                </div>                
                <div>
                    <div class="mobile">{$_('products.price')}</div>
                    <div>{item.price}</div>
                </div>
                <div>
                  <div class="mobile">{$_('products.commission')}</div>
                  <div>{item.fee_amount}</div>
                </div>
                <div>
                  <div class="mobile">{$_('products.sales')}</div>
                  <div>0</div>
                </div>

                <div class="actions">                 
                  {#if item.merchant_product_id > 0}
                  <button on:click={()=> { removeProductAction(item) }} class="remove border-t-1 border-custom-border-red bg-custom-bg-red text-white px-4 py-2 rounded-0">{$_('products.remove_product')}</button>
                  {:else}
                  <button on:click={()=> { addProductAction(item) }} class="border-t-1 border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-0">{$_('products.add_product')}</button>
                  {/if}                    
                </div>
            </div>
            {/each}
          </div>
          <Pagination {pages} on:previous={previous} on:next={next} {currentPage}></Pagination>
     
        </div>
    </div>
</div>